"use client"

import styles from "../../../styles/LandingPage/Patients.module.scss"
import StyledText from "../../typography/typography-component"
import skColors from "../../../styles/skColors"
import Image from "next/image"
import { useTranslations } from "next-intl"

const TherapySetSection = ({}) => {
  const t = useTranslations("index")

  return (
    <div
      style={{
        backgroundColor: skColors.grey[50],
      }}
      className={styles.therapySetContainer}
    >
      <div className={styles.therapySetTitle}>
        <StyledText color={skColors.turquoise[600]} variant={"h2"}>
          {t("therapySet.title")}
        </StyledText>
        <StyledText variant={"h3"}>{t("therapySet.subtitle")}</StyledText>
        <div className={styles.therapySetContent}>
          <div className={styles.therapySetText}>
            <StyledText variant={"pRegular"}>{t("therapySet.paragraph1")}</StyledText>
            <br />
            <StyledText variant={"pRegular"}>{t("therapySet.paragraph2")}</StyledText>
            <br />
            <StyledText variant={"pRegular"}>{t("therapySet.paragraph3")}</StyledText>
          </div>

          <Image
            className={styles.therapySetImage}
            src={"/images/therapyset/dermalight.webp"}
            alt={t("therapySet.title")}
            width={560}
            height={315}
            style={
              {
                // maxWidth: "100%",
                //height: "auto",
              }
            }
          />
        </div>
      </div>
    </div>
  )
}
export default TherapySetSection
